import { createReducer, on } from '@ngrx/store';
import { immerOn } from 'ngrx-immer/store';
import { sessionAuthData } from '../../interfaces/states-data';
import { __clearSessionAuth, __updateSessionAuth } from './session-auth.actions';

const initialState: sessionAuthData = { loggedIn: false };

export const sessionAuthReducer = createReducer(
    initialState,
    immerOn(__updateSessionAuth, (state, newState) => {
        return newState;
    }),
    immerOn(__clearSessionAuth, (state, newState) => {
        // Borrar estado y tokens del local storage
        localStorage.removeItem('sessionAuthState');
        return { loggedIn: false };
    }),
)